<template>
    <v-dialog v-model="dialog" max-width="610" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">{{ is_attached ? $t('attach.update_assigned') : $t('attach.assign')}}</h2>

                    <v-card-text class="px-0 text-center my-16">
                        <label for="file" class="text-decoration-underline green--text font-weight-bold mr-2">{{$t('attach.choose')}}</label>
                        <ValidationProvider vid="file" :name="$t('attach.choose')" rules="required|mimes:zip,pdf" v-slot="{ validate, errors }">
                            <input type="file" id="file" accept="application/zip,application/pdf" ref="file" @change="previewFiles() || validate($event)">
                            <span v-if="attachment.file" class="font-weight-bold">{{attachment.file.name}}</span>
                            <span v-else class="chosen">{{$t('attach.no_chosen')}}</span><br />
                            <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </v-card-text>

                    <v-card-actions class="d-flex justify-center">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest">{{$t('global.save')}}</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">{{$t('global.close')}}</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['lesson_id', 'is_attached'],
        data() {
            return {
                dialog: false,
                loadingRequest: false,
                attachment: {},
            }
        },

        methods: {
            save() {
                this.loadingRequest = true;
                let params = new FormData();

                params.append('file', this.attachment.file);
                params.append('model_id', this.lesson_id);
                params.append('type', 'lesson');

                this.$store.dispatch('ADD_ATTACHMENT', params).then(() => {
                    this.attachment = {};
                    this.$refs.form.reset();
                    this.$parent.$emit('getData');
                    this.dialog = false;
                    this.$store.dispatch('alert', {type: 1, message: this.$t('attach.success_attached')});
                }).catch((err) => {
                    if (err.response.status === 422) this.$refs.form.setErrors(err.response.data);
                }).finally(() => {
                    this.loadingRequest = false;
                })
            },

            previewFiles() {
                this.attachment.file = this.$refs.file.files[0];
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/components/dialog";
    @import "../../scss/components/Lessons/attach";
</style>